// extracted by mini-css-extract-plugin
module.exports = {"main-component":"leaderboard_main-component__2Zr1k"};